module.exports = __webpack_public_path__ + "img/arrow-analytics.9a312663.svg";